import React, { useState, useEffect } from "react";
import { Box, Heading, Flex, Container, VStack, Badge, useTheme } from "@chakra-ui/react"
import Table1 from "./components/Table1";
import { useSupplierRetailer } from "../../wrappers/SupplierRetailerContext";
import Exports from "./components/Exports";
const Ranging = () => {
  const { selectedRetailer, selectedSupplier } = useSupplierRetailer();
  const [loading, setLoading] = useState(false);
    const theme = useTheme()

  return (
    <Box minH="100vh" bg="gray.50" p={4}>
      <Container maxW="98vw" mx="auto">
        <VStack spacing={4} align="stretch">
          {/* Header Card */}
          <Box bg="white" borderRadius="lg" shadow="md" border="1px" borderColor="gray.200" p={2}>
            <Flex align="center" justify="space-between">
              <VStack align="start" spacing={1}>
                <Heading size="md" color={theme.colors.primary1} fontWeight="bold">
                  Ranging Report
                </Heading>
                <Flex gap={2}>
                  <Badge bg={theme.colors.primary1} color="white" px={1} py={0.5} borderRadius="md" fontSize="2xs">
                    Supplier: {selectedSupplier}
                  </Badge>
                  <Badge bg={theme.colors.secondary1} color="white" px={1} py={0.5} borderRadius="md" fontSize="2xs">
                    Retailer: {selectedRetailer}
                  </Badge>
                </Flex>
              </VStack>
              <Box position="relative" zIndex={2000}>
                <Exports supplier={selectedSupplier} retailer={selectedRetailer} />
              </Box>
            </Flex>
          </Box>

          {/* Table Card */}
          {loading ? (
            <Box bg="white" borderRadius="xl" shadow="lg" border="1px" borderColor="gray.200" p={8} textAlign="center">
              <VStack spacing={3}>
                <Box
                  w={8}
                  h={8}
                  border="3px"
                  borderColor={theme.colors.primary1}
                  borderTopColor="transparent"
                  borderRadius="full"
                  animation="spin 1s linear infinite"
                />
                <Heading size="md" color="gray.600">
                  Loading report data...
                </Heading>
              </VStack>
            </Box>
          ) : (
            <>
              <Box bg="white" borderRadius="xl" shadow="lg" border="1px" borderColor="gray.200" overflow="hidden">
                <Box
                   id="ranging-wrapper" 
                  maxHeight="75vh"
                  overflow="auto"
                  css={{
                    "&::-webkit-scrollbar": {
                      width: "6px",
                      height: "6px",
                    },
                    "&::-webkit-scrollbar-track": {
                      background: "#f1f1f1",
                      borderRadius: "6px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: theme.colors.primary1,
                      borderRadius: "6px",
                    },
                    "&::-webkit-scrollbar-thumb:hover": {
                      background: theme.colors.primary2,
                    },
                  }}
                >
                  <Table1 supplier={selectedSupplier} retailer={selectedRetailer} />
                </Box>
              </Box>
            </>
          )}
        </VStack>
      </Container>
    </Box>
  );
};

export default Ranging;
